<template>
  <div class="bumble">
    <img src="@/assets/promo/bumble_promo.png" alt="BumbleMe" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-BumbleMe/dp/B0092ATGIQ/ref=sr_1_7?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-7">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Fly Be Free!</h2>
    <br>
    <p class="app-blurb">To dodge or not to dodge. That is the question. Split decisions keep this bee
      flying. It's not easy being Me.
    </p>
    <br><br>
    <iframe
      src="https://www.youtube.com/embed/J5MAlTyum7c"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="embedHeight"></iframe>
    <img src="@/assets/screenshots/bumble_01.png" alt="">
    <img src="@/assets/screenshots/bumble_02.png" alt="">
    <img src="@/assets/screenshots/bumble_03.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'bumble',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.bumble {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
  margin: 0;
}
.bumble img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 60%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
